(() => {
  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('main-cart::refresh'));
      document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
      document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));;
    }, 2000);
    
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('main-cart::refresh'));
      document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
      document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));
    }, 4500);
  }
  
  document.addEventListener('click', function(event) {
    if (event.target.closest('.js-plus') || event.target.closest('.js-minus') || event.target.closest('.main-cart__line-item__remove')) {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('main-cart::refresh'));
        document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
        document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));
      }, 1500);
      
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('main-cart::refresh'));
        document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
        document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));
      }, 3500);
    }
  });
})();

// Wrap OG prices in a span with price-wrapper attribute
(() => {
  function wrapOgPrices() {
    document.querySelectorAll('og-optout-button og-price[regular]:not([data-wrapped])').forEach(el => {
      if (!el.parentNode) return;
      el.setAttribute('data-wrapped', '');
      const wrapper = document.createElement('span');
      wrapper.setAttribute('price-wrapper', '');
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    });
  }
  
  const tick = (tries = 60) => {
    wrapOgPrices();
    if (tries > 0) setTimeout(() => tick(tries - 1), 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tick());
  } else {
    tick();
  }
})();

// Dispatch a custom event when OG Buy Once / Subscribe buttons are selected
(() => {
  document.addEventListener('main-product:on-update', function (event) {
    [500, 800].forEach((delay) => setTimeout(() => window.Abra?.render(), delay));
  });

  document.addEventListener('click', function (event) {
    const optoutBtn = event.target.closest('.og-optout-btn');
    const optinBtn  = event.target.closest('.og-optin-btn');
    const btn       = optoutBtn || optinBtn;

    if (!btn) return;

    const eventDetail = {
      bubbles: true,
      detail: {
        type: optoutBtn ? 'buy-once' : 'subscribe',
        price: btn.dataset.price || null,
        productHandle: btn.closest('[data-shopify-product-handle]')?.dataset.shopifyProductHandle || null,
      },
    };

    const dispatchOgEvent = () => {
      window.dispatchEvent(new CustomEvent('og:purchase-type-selected', eventDetail));
      window.Abra?.render();
    };

    dispatchOgEvent();
    setTimeout(dispatchOgEvent, 500);
  });
})();
